var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check_FILL0_wght400_GRAD0_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.55211 19.5754C9.41877 19.5754 9.29377 19.5546 9.17711 19.5129C9.06044 19.4712 8.95211 19.4004 8.85211 19.3004L4.55211 15.0004C4.36877 14.8171 4.28127 14.5796 4.28961 14.2879C4.29794 13.9962 4.39377 13.7587 4.57711 13.5754C4.76044 13.3921 4.99377 13.3004 5.27711 13.3004C5.56044 13.3004 5.79377 13.3921 5.97711 13.5754L9.55211 17.1504L18.0271 8.67539C18.2104 8.49206 18.4479 8.40039 18.7396 8.40039C19.0313 8.40039 19.2688 8.49206 19.4521 8.67539C19.6354 8.85872 19.7271 9.09622 19.7271 9.38789C19.7271 9.67956 19.6354 9.91706 19.4521 10.1004L10.2521 19.3004C10.1521 19.4004 10.0438 19.4712 9.92711 19.5129C9.81044 19.5546 9.68544 19.5754 9.55211 19.5754Z",
    fill: "#1C359F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.a95aade5ed8e4716b230ffc62e6d0325.svg";
export { ForwardRef as ReactComponent };